import { Row, Select } from "antd";
import { useState, useEffect } from "react";

const { Option } = Select;

export const SelectCustom = ({
  idCampo,
  nombreCampo,
  arrayOpciones,
  textoOpciones,
  elValue,
  elPlaceholder,
  required,
  tipoError,
  error,
  onChange,
  disabled
}) => {
  const [selectedValue, setSelectedValue] = useState(elValue || null);
  let esRequired = required ? "*" : "";

  useEffect(() => {
    setSelectedValue(elValue || null);
  }, [elValue]);

  const handleSelectChange = (selectedValue) => {
    setSelectedValue(selectedValue);
    onChange({ target: { value: String(selectedValue), id: idCampo } });
  };

  return (
    <Row justify={"start"}>
      <label htmlFor={idCampo}>
        <p className="nombre-campo">{nombreCampo} {esRequired}</p>
      </label>
      <Select
      className="select-custom"
        disabled={disabled}
        showSearch
        autoComplete="none"
        key={idCampo + "*" + elValue}
        id={idCampo}
        onChange={handleSelectChange}
        placeholder={elPlaceholder}
        style={{ width: "100%" }}
        required={required}
        value={selectedValue !== null ? String(selectedValue) : undefined}
        filterOption={(input, option) =>
          (option.children || "").toLowerCase().includes(input.toLowerCase())
        }
        status={tipoError}
      >
        <Option key={"vacio"} value="">
          -
        </Option>
        {arrayOpciones.map((option) => (
          <Option key={option.id} value={String(option.id)}>
            {option[textoOpciones]}
          </Option>
        ))}
      </Select>
      <span className="spanErrores" style={{ color: "red" }}>
        <b>{error}</b>
      </span>
    </Row>
  );
};
